module.exports = __webpack_public_path__ + "static/structured-data-logo-96a7b6453fad200b012584fcb127009f.png";